export default {
  appResourceName: 'collections',
  hasuraResourceName: 'collection_view_deposits_summary',
  fields: [
    {
      app: 'amount',
      hasura: 'amount',
    },
    {
      app: 'created_at',
      hasura: 'created_at',
    },
    {
      app: 'id',
      hasura: 'id',
    },
    {
      app: 'currency',
      hasura: 'currency',
    },
    {
      app: 'customerId',
      hasura: 'customer_id',
    },
    {
      app: 'from',
      hasura: 'from',
    },
    {
      app: 'to',
      hasura: 'to',
    },
  ],
}
